import axios from "axios";
import {config} from "../../../../../enviroment"

export const loginService={
    login
}

async function login(username, password) {
    return new Promise((resolve, reject) => {
      axios
        .post(config.urls.LOGIN, {
          userName: username,
          password: password,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  